import {
  UPDATE_HAS_MORE,
  UPDATE_LOADING,
  UPDATE_PAGE,
  UPDATE_RATING_DATA,
  UPDATE_REVIEW_DATA,
} from './action';
import { ActionObject, StateType } from './types';

// review reducer
export default function Reviewreducer(
  state: StateType,
  action: ActionObject
): StateType {
  switch (action.type) {
    case UPDATE_REVIEW_DATA: {
      return {
        ...state,
        reviewsData: [...state.reviewsData, ...action.reviewsData],
      };
    }
    case UPDATE_PAGE: {
      return {
        ...state,
        page: action.page,
      };
    }
    case UPDATE_HAS_MORE: {
      return {
        ...state,
        hasMore: action.hasMore,
      };
    }
    case UPDATE_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }
    case UPDATE_RATING_DATA: {
      return {
        ...state,
        ratingData: action.ratingData,
      };
    }
  }
}
